module.exports = __webpack_public_path__ + "static/media/banner.94739591.jpg";